<div class="flex items-center justify-center gap-2" [class.opacity-50]="isDisabled">
    @for (digit of digits; track $index; let i = $index) {
        <input
            #digitInput
            type="text"
            inputmode="numeric"
            maxlength="1"
            [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
            [value]="digit"
            [disabled]="isDisabled"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            (paste)="onPaste($event, i)"
            (focus)="onFocus($event)"
            class="w-[50px] h-[50px] text-center text-[20px] font-medium leading-none text-[#022D35] placeholder:text-[#022D3540] bg-[#FFFFFF] border border-solid rounded-[6px] outline-none focus:border-[#022D35] read-only:opacity-30 disabled:opacity-30 transition-colors"
            [ngClass]="{
                '!border-[#C93535]': error,
                'border-[#D8E1E1]': bordered && !error,
                'border-[#FFFFFF]': !bordered && !error
            }"
        />
    }
</div>
